/* eslint-disable no-undefined */
import React from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useCustomerMessageContext } from "../../../hooks";
import { useTranslation } from "@limitless/common/hooks/translation/TranslationContext";
import ActionControlsFooter from "../action-controls-footer/ActionControlsFooter";
import TimeSinceFooter from "../time-since-footer/TimeSinceFooter";
import ResponseBox from "../../response-box/ResponseBox";
import FooterTitle from "../footer-title/FooterTitle";
import CSATFooter from "../csat-footer/CSATFooter";
import ClosedMessageFooter from "../closed-message-footer/ClosedMessageFooter";
import { withi18n } from "../../hocs/i18n";
import LoadingFooter from "../loading-footer/LoadingFooter";
import RateFinishMessageOverlay from "../rate-finish-message-overlay/RateFinishMessageOverlay";
import ButtonFooter from "../button-footer/ButtonFooter";
import withStyles from "@mui/styles/withStyles";
import { MESSAGE_STATE_NEW, MESSAGE_STATE_ACCEPT_ANSWER_PROMPT, MESSAGE_STATE_RATE_AMBASSADOR, MESSAGE_STATE_CLOSED, MESSAGE_STATE_SUGGESTED_ANSWER, MESSAGE_STATE_TIMEDOUT, MESSAGE_STATE_REPORTED, MESSAGE_STATE_FORWARDED, MESSAGE_STATE_RERATE_YOUR_EXPERIENCE, MESSAGE_STATE_PENDING_CLOSURE, MESSAGE_CUSTOMER_OPINION_ACCEPT, MESSAGE_CUSTOMER_OPINION_SCORE, MESSAGE_STATE_LOADING } from "../../../utils";
import { wrapTextForRTL } from "../rate-finish-message-overlay/TestimonialScreen";
const ConversationFooter = ({
  classes,
  scrollConversationCallback,
  suggestedAnswerHandle,
  rejectSuggestedAnswerHandle,
  newMessageHandle,
  testimonialFullScreen,
  mockFooter,
  isMobileDevice
}) => {
  var _message$custClientRe, _message$custClientRe2;
  const [isTyping, setTyping] = React.useState(false);
  const [dialogVisibility, setDialogVisibility] = React.useState(false);
  const [hasCustomerClosed, setHasCustomerClosed] = React.useState(false);
  const [hasClickedCustomerAccept, setHasClickedCustomerAccept] = React.useState(false);
  const [isImageView, setIsImageView] = React.useState(false);
  const [isImageViewError, setIsImageViewError] = React.useState(false);
  const [hasClickedRateExperience, setHasClickedRateExperience] = React.useState(false);
  const [hasMaliciousContent, setHasMaliciousContent] = React.useState(false);
  const {
    message,
    acceptAnswer,
    submitScore,
    addDialogue,
    submitTestimonial,
    submitNPSNFeedback,
    previewImage
  } = useCustomerMessageContext();
  const {
    t
  } = useTranslation();
  const [isNPSFinished, setIsNPSFinished] = React.useState((_message$custClientRe = (_message$custClientRe2 = message.custClientReview) === null || _message$custClientRe2 === void 0 ? void 0 : _message$custClientRe2.feedback) !== null && _message$custClientRe !== void 0 ? _message$custClientRe : false);
  const isNPSRequired = React.useMemo(() => {
    var _message$custClientRe3;
    return message.isNPSEnabled && (!((_message$custClientRe3 = message.custClientReview) !== null && _message$custClientRe3 !== void 0 && _message$custClientRe3.feedback) || !isNPSFinished || message.footerState === MESSAGE_STATE_RERATE_YOUR_EXPERIENCE);
  }, [message, isNPSFinished]);
  React.useEffect(() => {
    const {
      messageId,
      accepted,
      customerScore,
      custTestimonial,
      lastExpertDialogueDate,
      acceptedDate,
      footerState
    } = message;
    if (messageId && accepted && (!customerScore || !custTestimonial || isNPSRequired)) {
      if (lastExpertDialogueDate < acceptedDate && !hasCustomerClosed) {
        setDialogVisibility(true);
      }
    }
    if (!isNPSRequired && custTestimonial && footerState === MESSAGE_STATE_CLOSED) {
      setDialogVisibility(false);
    }
  }, [message.accepted, message.customerScore, message.custResolved, message.custTestimonial, isNPSRequired]);

  /* to handle the scenario where a customer is viewing a message that has it's lifecycle restarted */
  React.useEffect(() => {
    if (message.accepted === undefined && hasClickedCustomerAccept) {
      setHasClickedCustomerAccept(false);
    }
  }, [message.accepted]);
  React.useEffect(() => {
    if (previewImage) {
      setIsImageView(true);
    }
  }, []);
  const responseBoxSubmitHandle = (response, isViewImageError = false, isViewImage = false, callback) => {
    setIsImageView(isViewImage);
    setIsImageViewError(isViewImageError);
    if (!mockFooter) {
      if (response) {
        addDialogue(response, callback);
      }
    }
  };
  const acceptAnswerHandle = () => {
    if (!mockFooter) {
      acceptAnswer(true, () => {
        //wait for callback before
        setDialogVisibility(true);
      });
    } else {
      setHasClickedCustomerAccept(false);
    }
  };
  const getCommonScoreAndReview = () => {
    var _message$custClientRe4, _message$custClientRe5;
    return {
      clientScore: (_message$custClientRe4 = message.custClientReview) === null || _message$custClientRe4 === void 0 ? void 0 : _message$custClientRe4.score,
      feedback: (_message$custClientRe5 = message.custClientReview) === null || _message$custClientRe5 === void 0 ? void 0 : _message$custClientRe5.feedback
    };
  };
  const getCommonResolvedAndExpertScore = () => {
    var _message$custClientRe6, _message$custClientRe7;
    return {
      ...getCommonScoreAndReview(),
      custClientResolved: (_message$custClientRe6 = message.custClientReview) === null || _message$custClientRe6 === void 0 ? void 0 : _message$custClientRe6.resolved,
      custClientExpertScore: (_message$custClientRe7 = message.custClientReview) === null || _message$custClientRe7 === void 0 ? void 0 : _message$custClientRe7.expertScore
    };
  };
  const rejectAnswerHandle = () => {
    if (!mockFooter) {
      acceptAnswer(false);
      setHasClickedCustomerAccept(false);
    } else {
      setHasClickedCustomerAccept(false);
    }
  };
  const submitCSATHandle = (score, callback) => {
    if (!mockFooter) {
      submitScore(score, callback);
    }
  };
  const submitNPSHandle = (score, cb) => {
    if (!mockFooter && typeof score === "number") {
      submitNPSNFeedback({
        clientScore: score
      }, "Unable to submit a brand score", cb);
    }
  };
  const submitResolutionHandle = (custClientResolved, cb) => {
    if (!mockFooter) {
      submitNPSNFeedback({
        ...getCommonScoreAndReview(),
        custClientResolved
      }, "Unable to submit Expert resolution", cb);
    }
  };
  const submitResolutionContactHandle = (custClientResolved, cb) => {
    if (!mockFooter) {
      submitNPSNFeedback({
        ...getCommonScoreAndReview(),
        custClientExpertFeedback: custClientResolved === null || custClientResolved === void 0 ? void 0 : custClientResolved.expertFeedback,
        custClientGeneralFeedback: custClientResolved === null || custClientResolved === void 0 ? void 0 : custClientResolved.generalFeedback,
        feedback: custClientResolved === null || custClientResolved === void 0 ? void 0 : custClientResolved.feedback
      }, "Unable to submit Expert resolution-contact", cb);
    }
  };
  const submitExpertScoreHandle = (custClientExpertScore, cb) => {
    if (!mockFooter) {
      var _message$custClientRe8;
      submitNPSNFeedback({
        ...getCommonScoreAndReview(),
        custClientResolved: (_message$custClientRe8 = message.custClientReview) === null || _message$custClientRe8 === void 0 ? void 0 : _message$custClientRe8.resolved,
        custClientExpertScore
      }, "Unable to submit expert score", cb);
    }
  };
  const submitExpertFeedbackHandle = (custClientExpertFeedback, cb) => {
    if (!mockFooter) {
      submitNPSNFeedback({
        ...getCommonResolvedAndExpertScore(),
        custClientExpertFeedback
      }, "Unable to submit expert feedback", cb);
    }
  };
  const submitGeneralFeedbackHandle = (custClientGeneralFeedback, cb) => {
    if (!mockFooter) {
      var _message$custClientRe9;
      submitNPSNFeedback({
        ...getCommonResolvedAndExpertScore(),
        custClientExpertFeedback: (_message$custClientRe9 = message.custClientReview) === null || _message$custClientRe9 === void 0 ? void 0 : _message$custClientRe9.expertFeedback,
        custClientGeneralFeedback
      }, "Unable to submit general feedback", cb);
    }
  };
  const submitNPSFeedbackHandle = (feedback, cb) => {
    if (!mockFooter) {
      submitNPSNFeedback({
        clientScore: message.custClientReview.score,
        feedback
      }, "Unable to submit a brand feedback", cb);
    }
  };
  const handleCustomerAccept = () => {
    setHasClickedCustomerAccept(true);
  };
  const renderResponseBox = () => {
    return /*#__PURE__*/React.createElement(ResponseBox, {
      onClickHandle: responseBoxSubmitHandle,
      scrollConversationCallback: scrollConversationCallback,
      message: message,
      onMaliciousContentChange: setHasMaliciousContent
    });
  };
  const renderCustomerOpinionAccept = () => {
    if (hasClickedCustomerAccept) {
      return renderAmbassadorResponseFooter();
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "conversation-footer-container"
    }, renderResponseBox(), !previewImage && /*#__PURE__*/React.createElement(ButtonFooter, {
      onClick: handleCustomerAccept,
      title: "Does this answer your question?",
      id: "customerAcceptButton"
    }));
  };
  const renderNewConversationFooter = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: "conversation-footer-container"
    }, renderResponseBox(), hasMaliciousContent && /*#__PURE__*/React.createElement(FooterTitle, {
      classes: {
        caption: classes.caption
      },
      title: t("Script tags or malicious content detected. Please remove to proceed."),
      position: "bottom"
    }), isImageViewError ? /*#__PURE__*/React.createElement(FooterTitle, {
      classes: {
        caption: classes.caption
      },
      title: t("File size is too big. Max file size is 5MB"),
      position: "bottom"
    }) : !isImageView && !hasMaliciousContent && /*#__PURE__*/React.createElement(TimeSinceFooter, null));
  };
  const renderRateFinishFooter = () => {
    return /*#__PURE__*/React.createElement(RateFinishMessageOverlay, {
      open: dialogVisibility,
      message: message,
      onSubmitNPSFeedback: submitNPSFeedbackHandle,
      onSubmitNPS: submitNPSHandle,
      onSubmitResoluation: submitResolutionHandle,
      onSubmitExpertScore: submitExpertScoreHandle,
      onSubmitResoluationContact: submitResolutionContactHandle,
      onSubmitExpertFeedback: submitExpertFeedbackHandle,
      onSubmitGeneralFeedback: submitGeneralFeedbackHandle,
      onSubmitCSATScore: submitCSATHandle,
      isNPSRequired: isNPSRequired,
      onSubmitTestimonial: testimonial => {
        submitTestimonial(testimonial);
        if (!isNPSRequired) {
          setIsNPSFinished(true);
          setHasCustomerClosed(true);
          setDialogVisibility(false);
        }
      },
      fullScreen: testimonialFullScreen,
      onCancelDialog: (skipNPS = false) => {
        if (!isNPSRequired || skipNPS) {
          setIsNPSFinished(true);
          setHasCustomerClosed(true);
          setDialogVisibility(false);
        }
      },
      isMobileDevice: isMobileDevice
    });
  };
  const renderSuggestedAnswerFooter = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: "conversation-footer-container"
    }, /*#__PURE__*/React.createElement(FooterTitle, {
      title: wrapTextForRTL("Are you happy with the suggested answer?")
    }), /*#__PURE__*/React.createElement(ActionControlsFooter, {
      leftButtonTitle: "Yes",
      leftButtonHandle: () => suggestedAnswerHandle(() => {
        setDialogVisibility(true);
      }),
      rightButtonTitle: "Continue",
      rightButtonHandle: rejectSuggestedAnswerHandle
    }));
  };
  const isRtl = document.documentElement.getAttribute("dir") === "rtl";
  const adjustedPlaceholder = isRtl ? `\u202A${t("Does this answer your question ?")}\u202C` : t("Does this answer your question ?");
  const renderAmbassadorResponseFooter = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: "conversation-footer-container"
    }, /*#__PURE__*/React.createElement(FooterTitle, {
      title: adjustedPlaceholder
    }), /*#__PURE__*/React.createElement(ActionControlsFooter, {
      leftButtonTitle: "Yes",
      leftButtonHandle: acceptAnswerHandle,
      rightButtonTitle: "Continue",
      rightButtonHandle: rejectAnswerHandle
    }));
  };
  const renderRateAmbassadorFooter = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: "conversation-footer-container"
    }, /*#__PURE__*/React.createElement(ResponseBox, {
      onClickHandle: responseBoxSubmitHandle,
      scrollConversationCallback: scrollConversationCallback,
      onTypingHandler: flag => setTyping(flag),
      message: message
    }), !previewImage && /*#__PURE__*/React.createElement(CSATFooter, {
      onClickHandle: submitCSATHandle,
      message: message,
      isTyping: isTyping
    }));
  };
  const renderCustomerRateExperience = () => {
    if (hasClickedRateExperience) {
      return renderRateAmbassadorFooter();
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "conversation-footer-container"
    }, renderResponseBox(), !previewImage && /*#__PURE__*/React.createElement(ButtonFooter, {
      onClick: () => setHasClickedRateExperience(true),
      title: "Rate your experience",
      id: "rateYourExperienceButton"
    }));
  };
  const renderRerateExperience = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: "conversation-footer-container"
    }, renderResponseBox(), !previewImage && /*#__PURE__*/React.createElement(ButtonFooter, {
      onClick: () => setDialogVisibility(true),
      title: "Rate your experience",
      id: "rateYourExperienceButton"
    }));
  };
  const renderTitleFooter = title => {
    return /*#__PURE__*/React.createElement("div", {
      className: "conversation-footer-container"
    }, /*#__PURE__*/React.createElement(FooterTitle, {
      title: t(title)
    }), /*#__PURE__*/React.createElement(ClosedMessageFooter, {
      message: message,
      onButtonClick: newMessageHandle
    }));
  };
  const renderLoading = () => {
    return /*#__PURE__*/React.createElement(LoadingFooter, null);
  };
  const {
    footerState
  } = message;
  const TITLES = {
    [MESSAGE_STATE_TIMEDOUT]: "Your question has timed out and been forwarded",
    [MESSAGE_STATE_REPORTED]: "This question has been reported and is being reviewed",
    [MESSAGE_STATE_FORWARDED]: "Your Question has been forwarded",
    [MESSAGE_STATE_CLOSED]: "Your question has been successfully answered",
    [MESSAGE_STATE_PENDING_CLOSURE]: "Thank you for your feedback"
  };
  const FOOTER_MAP = {
    [MESSAGE_STATE_SUGGESTED_ANSWER]: {
      renderMethod: renderSuggestedAnswerFooter
    },
    [MESSAGE_STATE_ACCEPT_ANSWER_PROMPT]: {
      renderMethod: renderAmbassadorResponseFooter
    },
    [MESSAGE_STATE_RATE_AMBASSADOR]: {
      renderMethod: renderRateAmbassadorFooter
    },
    [MESSAGE_STATE_TIMEDOUT]: {
      renderMethod: renderTitleFooter,
      renderParam: TITLES[footerState]
    },
    [MESSAGE_STATE_REPORTED]: {
      renderMethod: renderTitleFooter,
      renderParam: TITLES[footerState]
    },
    [MESSAGE_STATE_FORWARDED]: {
      renderMethod: renderTitleFooter,
      renderParam: TITLES[footerState]
    },
    [MESSAGE_STATE_CLOSED]: {
      renderMethod: renderTitleFooter,
      renderParam: TITLES[footerState]
    },
    [MESSAGE_STATE_LOADING]: {
      renderMethod: renderLoading
    },
    [MESSAGE_STATE_NEW]: {
      renderMethod: renderNewConversationFooter
    },
    [MESSAGE_STATE_RERATE_YOUR_EXPERIENCE]: {
      renderMethod: renderRerateExperience
    },
    [MESSAGE_STATE_PENDING_CLOSURE]: {
      renderMethod: renderTitleFooter,
      renderParam: TITLES[footerState]
    },
    [MESSAGE_CUSTOMER_OPINION_ACCEPT]: {
      renderMethod: renderCustomerOpinionAccept
    },
    [MESSAGE_CUSTOMER_OPINION_SCORE]: {
      renderMethod: renderCustomerRateExperience
    }
  };
  const {
    renderMethod,
    renderParam
  } = FOOTER_MAP[footerState];
  const getFooterContainer = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, renderMethod(renderParam), dialogVisibility && renderRateFinishFooter());
  };
  return /*#__PURE__*/React.createElement("div", null, !message.messageId ? renderMethod(MESSAGE_STATE_LOADING) : getFooterContainer());
};
const styles = theme => ({
  caption: {
    color: theme.palette.error.main
  }
});
export default withStyles(styles)(withi18n(ConversationFooter));
ConversationFooter.propTypes = {
  classes: PropTypes.object,
  scrollConversationCallback: PropTypes.func.isRequired,
  suggestedAnswerHandle: PropTypes.func.isRequired,
  rejectSuggestedAnswerHandle: PropTypes.func.isRequired,
  newMessageHandle: PropTypes.func,
  testimonialFullScreen: PropTypes.bool,
  mockFooter: PropTypes.bool,
  isMobileDevice: PropTypes.bool.isRequired
};
ConversationFooter.defaultProps = {
  mockFooter: false
};